/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Meta_TitleInputs */

const es_admin_meta_title = /** @type {(inputs: Admin_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Panel de administrador`)
};

const en_admin_meta_title = /** @type {(inputs: Admin_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Admin Panel`)
};

/**
* | output |
* | --- |
* | "Nexata \| Admin Panel" |
*
* @param {Admin_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_meta_title = /** @type {((inputs?: Admin_Meta_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Meta_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_meta_title(inputs)
	return en_admin_meta_title(inputs)
});
export { admin_meta_title as "admin.meta.title" }